import React, { Fragment } from 'react';
import { Checkbox, DatePicker, Form, Input, Radio, Select } from 'antd';
import UploadPhoto from '../../../../../common/components/UploadPhoto/UploadPhoto';
import { API_USER_PHOTO_UPLOAD } from '../../../../Authorization/api/constants';
import moment from 'moment';
import DadataSearch from '../../../../Authorization/containers/DadataSearch/dadataSearch';

const DateFormat = 'DD.MM.YYYY';

const requiredFieldRules = {
  required: true,
  message: 'Поле, обязательное для заполнения',
};

const TaxSystem = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="add-licensee__item">
      <span className="label">Система налогообложения:</span>
      <Form.Item>
        {getFieldDecorator('taxSystem', {
          rules: [requiredFieldRules],
        })(
          <Select
            style={{ width: 224 }}
            placeholder="Выберите с или без НДС"
            getPopupContainer={trigger => trigger.parentNode}
          >
            <Select.Option value={0}>Без НДС</Select.Option>
            <Select.Option value={1}>С НДС</Select.Option>
          </Select>
        )}
      </Form.Item>
    </div>
  );
};

const OtherInfo = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <React.Fragment>
      <div className="add-licensee__item">
        <span className="label">Фактический адрес:</span>
        <Form.Item>
          {getFieldDecorator('addressFact')(
            <Input
              style={{ width: 368 }}
              placeholder="Укажите фактический адрес"
            />
          )}
        </Form.Item>
      </div>
      <div className="add-licensee__item">
        <span className="label">ID в АЦБПДП:</span>
        {getFieldDecorator('acbpdp')(
          <Form.Item>
            <Input
              style={{ width: 368 }}
              placeholder="Укажите код перевозчика в ЕГИС ОТБ"
            />
          </Form.Item>
        )}
      </div>
      <div className="add-licensee__item">
        <span className="label">Сайт:</span>
        <Form.Item>
          {getFieldDecorator('web_cite')(
            <Input style={{ width: 368 }} placeholder="Укажите сайт" />
          )}
        </Form.Item>
      </div>
    </React.Fragment>
  );
};

const Emails = ({ form }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const emailMatch = getFieldValue('emailMatch');
  const handleChange = val => {
    const email = form.getFieldValue('email');
    email &&
      setFieldsValue({
        email_representative: email,
      });
    console.log('handleChange', val);
  };
  return (
    <div className="add-licensee__item-emails">
      <div className="add-licensee__item">
        <span className="label">E-mail для уведомлений:</span>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [requiredFieldRules],
          })(<Input style={{ width: 368 }} placeholder="Укажите e-mail" />)}
        </Form.Item>
      </div>
      <div className="add-licensee__item">
        <span className="label">E-mail для уведомлений:</span>
        <Form.Item>
          {getFieldDecorator('email_representative', {
            rules: [requiredFieldRules],
          })(
            <Input
              style={{ width: 368 }}
              disabled={!!emailMatch}
              placeholder="Укажите e-mail"
            />
          )}
        </Form.Item>
      </div>
      <div className="add-licensee__item">
        <span className="label" />
        <Form.Item>
          {getFieldDecorator('emailMatch', {
            valuePropName: 'checked',
          })(
            <Checkbox
              disabled={!!emailMatch}
              onClick={handleChange}
              style={{ color: '#9b9b9b', fontWeight: 'normal' }}
            >
              Совпадает с e-mail для уведомлений
            </Checkbox>
          )}
        </Form.Item>
      </div>
    </div>
  );
};

const AddPerformerFields = ({ form }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const subject = getFieldValue('subject');
  let disabled;
  const handleChange = val => {
    console.log('handleChange', val);
    val &&
      setFieldsValue({
        nameLegal: val.name,
        addressLegal: val.address,
        registratonDate: val.dateRegistered,
        inn: val.inn,
        kpp: val.kpp,
        ogrn: val.ogrn,
      });
  };
  const userId = getFieldValue('userId');
  const nameLegal = getFieldValue('nameLegal');
  const autoSearchCompany = getFieldValue('autoSearchCompany');
  if (nameLegal) {
    disabled = true;
  }
  return (
    <div className="add-licensee__form" style={{ marginBottom: 16 }}>
      <div className="add-licensee__item">
        <span className="label">Лицензиат:</span>
        <Form.Item>
          {getFieldDecorator('subject')(
            <Radio.Group>
              <Radio value="5">Физическое лицо</Radio>
              <Radio value="4">Юридическое лицо</Radio>
              <Radio value="6">ИП</Radio>
            </Radio.Group>
          )}
        </Form.Item>
      </div>
      {subject && (
        <Fragment>
          <div
            style={{
              position: 'absolute',
              top: 20,
              right: 20,
              zIndex: 1,
              marginRight: 8,
            }}
          >
            <Form.Item>
              {getFieldDecorator('photo', {
                rules: [],
                valuePropName: 'image_url',
              })(
                <UploadPhoto
                  name={'photo'}
                  data={{ user_id: userId }}
                  action={API_USER_PHOTO_UPLOAD}
                />
              )}
            </Form.Item>
          </div>
          {subject === '5' ? (
            <div className="add-licensee__item__ur-group visible">
              <div className="add-licensee__item">
                <span className="label">Фамилия:</span>
                <Form.Item>
                  {getFieldDecorator('lastname', {
                    rules: [requiredFieldRules],
                  })(
                    <Input
                      style={{ width: 368 }}
                      disabled={disabled}
                      placeholder="Укажите фамилию"
                    />
                  )}
                </Form.Item>
              </div>
              <div className="add-licensee__item">
                <span className="label">Имя:</span>
                <Form.Item>
                  {getFieldDecorator('name', {
                    rules: [requiredFieldRules],
                  })(
                    <Input
                      style={{ width: 368 }}
                      disabled={disabled}
                      placeholder="Укажите имя"
                    />
                  )}
                </Form.Item>
              </div>
              <div className="add-licensee__item">
                <span className="label">Отчество:</span>
                <Form.Item>
                  {getFieldDecorator('patronymic', {
                    rules: [requiredFieldRules],
                  })(
                    <Input
                      style={{ width: 368 }}
                      disabled={disabled}
                      placeholder="Укажите фамилию"
                    />
                  )}
                </Form.Item>
              </div>
              <div className="add-licensee__item">
                <span className="label">Дата рождения:</span>
                <Form.Item>
                  {getFieldDecorator('birthDate', {
                    rules: [requiredFieldRules],
                  })(
                    <DatePicker
                      style={{ width: 224 }}
                      format={DateFormat}
                      placeholder="Укажите дату рождения"
                      disabled={disabled}
                    />
                  )}
                </Form.Item>
                <span
                  className="label"
                  style={{
                    width: 'auto',
                    /* fix при пустом значении */ height: 'auto',
                  }}
                >
                  {getFieldValue('birthDate') &&
                    moment(getFieldValue('birthDate')).fromNow(true)}
                </span>
              </div>
              <Emails form={form} />
              <div className="add-licensee__item">
                <span className="label">ИНН:</span>
                <Form.Item>
                  {getFieldDecorator('inn')(
                    <Input style={{ width: 368 }} placeholder="Укажите ИНН" />
                  )}
                </Form.Item>
              </div>
              <div className="add-licensee__item">
                <span className="label">Место рождения:</span>
                <Form.Item>
                  {getFieldDecorator('birthPlace')(
                    <Input
                      style={{ width: 368 }}
                      placeholder="Укажите место рождения"
                    />
                  )}
                </Form.Item>
              </div>
              <div className="add-licensee__item">
                <span className="label">Сайт:</span>
                <Form.Item>
                  {getFieldDecorator('web_cite')(
                    <Input style={{ width: 368 }} placeholder="Укажите сайт" />
                  )}
                </Form.Item>
              </div>
            </div>
          ) : (
            <div className="add-licensee__item__ur-group visible">
              <span className="offer-card__non-label">
                <Form.Item>
                  {getFieldDecorator('autoSearchCompany', {
                    valuePropName: 'checked',
                  })(
                    <Checkbox onClick={null} disabled={disabled}>
                      Автоматическое определение данных организации по
                      наименованию или ИНН
                    </Checkbox>
                  )}
                </Form.Item>
              </span>
              <div className="add-licensee__item">
                {autoSearchCompany && (
                  <DadataSearch
                    style={{ width: 368 }}
                    label={
                      <span className="label">
                        {subject === 'individ' ? 'ИП' : 'Организация'}:
                      </span>
                    }
                    handleChange={handleChange}
                  />
                )}
              </div>
              <div className="add-licensee__item">
                <span className="label">Наименование:</span>
                <Form.Item>
                  {getFieldDecorator('nameLegal')(
                    <Input
                      disabled={autoSearchCompany || disabled}
                      style={{ width: 368 }}
                      placeholder="Укажите наименование компании"
                    />
                  )}
                </Form.Item>
              </div>
              <Fragment>
                <div className="add-licensee__item">
                  <span className="label">Юридический адрес:</span>
                  <Form.Item>
                    {getFieldDecorator('addressLegal')(
                      <Input
                        disabled={autoSearchCompany || disabled}
                        style={{ width: 368 }}
                        placeholder="Укажите юридический адрес"
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="add-licensee__item">
                  <span className="label">Дата регистрации:</span>
                  <Form.Item>
                    {getFieldDecorator('registratonDate')(
                      <DatePicker
                        style={{ width: 224 }}
                        format={DateFormat}
                        placeholder="Укажите дату регистрации"
                        disabled={autoSearchCompany || disabled}
                      />
                    )}
                  </Form.Item>
                </div>
              </Fragment>
              <div className="add-licensee__item">
                <span className="label">ИНН:</span>
                <Form.Item>
                  {getFieldDecorator('inn')(
                    <Input
                      disabled={autoSearchCompany || disabled}
                      style={{ width: 368 }}
                      placeholder="Укажите ИНН"
                    />
                  )}
                </Form.Item>
              </div>
              <Fragment>
                <div className="add-licensee__item">
                  <span className="label">КПП:</span>
                  <Form.Item>
                    {getFieldDecorator('kpp')(
                      <Input
                        disabled={autoSearchCompany || disabled}
                        style={{ width: 368 }}
                        placeholder="Укажите КПП"
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="add-licensee__item">
                  <span className="label">ОРГН:</span>
                  <Form.Item>
                    {getFieldDecorator('ogrn')(
                      <Input
                        disabled={autoSearchCompany || disabled}
                        style={{ width: 368 }}
                        placeholder="Укажите ОРГН"
                      />
                    )}
                  </Form.Item>
                </div>
              </Fragment>
              <TaxSystem form={form} />
              <Emails form={form} />
              <OtherInfo form={form} />
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default AddPerformerFields;
